import { render, staticRenderFns } from "./AtomicImport.vue?vue&type=template&id=16238d41"
import script from "./AtomicImport.vue?vue&type=script&lang=js"
export * from "./AtomicImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports